import { WatermarkIcon } from './WatermarkIcon';

/**
 * author: Google
 * id 20907A4A-11CA-447E-A4F5-D0F0901D197E
 * name watermark
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/watermark.svg
 * tags
 */
export const BrandingWatermarkIcon = WatermarkIcon;
export default BrandingWatermarkIcon